export default class gridPalkkiVisibilityClass {
  static async getAsiakasList(palkkiId, token) {
    const requestOptions = {
      method: "GET",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/grid/palkki/visibility/asiakas/list/" + palkkiId,
      requestOptions
    ).catch((error) => console.log(error));
    return response.json();
  }

  static async deleteAsiakas(palkkiId, asiakasId, token) {
    const requestOptions = {
      method: "DELETE",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL +
        "/api/grid/palkki/visibility/asiakas/delete/" +
        palkkiId +
        "/" +
        asiakasId,
      requestOptions
    ).catch((error) => console.log(error));
    return response.ok;
  }

  static async addAsiakas(palkkiId, asiakasId, token) {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        palkkiId: palkkiId,
        asiakasId: asiakasId,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/grid/palkki/visibility/asiakas/add",
      requestOptions
    ).catch((error) => console.log(error));
    return response.ok;
  }
}
